import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavMenuComponent } from './features/main/nav-menu/nav-menu.component';
import { FooterComponent } from './features/main/footer/footer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavMenuComponent, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly title = signal('lighthouse-app');
}
